import ThemeOne from './theme.json';

const typography = {
  h1: {
    fontFamily: ThemeOne.h1.fontFamily,
    fontWeight: ThemeOne.h1.fontWeight,
    fontSize: ThemeOne.h1.fontSize,
    fontStyle: ThemeOne.h1.fontStyle,
    lineHeight: ThemeOne.h1.lineHeight
  },
  h2: {
    fontFamily: ThemeOne.h2.fontFamily,
    fontWeight: ThemeOne.h2.fontWeight,
    fontSize: ThemeOne.h2.fontSize,
    fontStyle: ThemeOne.h2.fontStyle,
    lineHeight: ThemeOne.h2.lineHeight
  },
  h3: {
    fontFamily: ThemeOne.h3.fontFamily,
    fontWeight: ThemeOne.h3.fontWeight,
    fontSize: ThemeOne.h3.fontSize,
    fontStyle: ThemeOne.h3.fontStyle,
    lineHeight: ThemeOne.h3.lineHeight
  },
  h4: {
    fontFamily: ThemeOne.h4.fontFamily,
    fontWeight: ThemeOne.h4.fontWeight,
    fontSize: ThemeOne.h4.fontSize,
    fontStyle: ThemeOne.h4.fontStyle,
    lineHeight: ThemeOne.h4.lineHeight
  },
  h5: {
    fontFamily: ThemeOne.h5.fontFamily,
    fontWeight: ThemeOne.h5.fontWeight,
    fontSize: ThemeOne.h5.fontSize,
    fontStyle: ThemeOne.h5.fontStyle,
    lineHeight: ThemeOne.h5.lineHeight
  },
  h6: {
    fontFamily: ThemeOne.h6.fontFamily,
    fontWeight: ThemeOne.h6.fontWeight,
    fontSize: ThemeOne.h6.fontSize,
    fontStyle: ThemeOne.h6.fontStyle,
    lineHeight: ThemeOne.h6.lineHeight
  },
  subtitle1: {
    fontFamily: ThemeOne.subtitle1.fontFamily,
    fontWeight: ThemeOne.subtitle1.fontWeight,
    fontSize: ThemeOne.subtitle1.fontSize,
    fontStyle: ThemeOne.subtitle1.fontStyle,
    lineHeight: ThemeOne.subtitle1.lineHeight
  },
  subtitle2: {
    fontFamily: ThemeOne.subtitle2.fontFamily,
    fontWeight: ThemeOne.subtitle2.fontWeight,
    fontSize: ThemeOne.subtitle2.fontSize,
    fontStyle: ThemeOne.subtitle2.fontStyle,
    lineHeight: ThemeOne.subtitle2.lineHeight
  },
  body: {
    fontFamily: ThemeOne.body.fontFamily,
    fontWeight: ThemeOne.body.fontWeight,
    fontSize: ThemeOne.body.fontSize,
    fontStyle: ThemeOne.body.fontStyle,
    lineHeight: ThemeOne.body.lineHeight
  },
  body1: {
    fontFamily: ThemeOne.body1.fontFamily,
    fontWeight: ThemeOne.body1.fontWeight,
    fontSize: ThemeOne.body1.fontSize,
    fontStyle: ThemeOne.body1.fontStyle,
    lineHeight: ThemeOne.body1.lineHeight
  },

  // button: {
  //   fontFamily: ThemeOne.button.fontFamily,
  //   fontWeight: ThemeOne.button.fontWeight,
  //   fontSize: ThemeOne.button.fontSize,
  //   fontStyle: ThemeOne.button.fontStyle,
  //   "text-transform": ThemeOne.button.textTransform,
  // },
  // caption: {
  //   fontFamily: ThemeOne.caption.fontFamily,
  //   fontWeight: ThemeOne.caption.fontWeight,
  //   fontSize: ThemeOne.caption.fontSize,
  //   // "text-transform": ThemeOne.caption.textTransform,
  // },
  // overline: {
  //   fontFamily: ThemeOne.overline.fontFamily,
  //   fontWeight: ThemeOne.overline.fontWeight,
  //   fontSize: ThemeOne.overline.fontSize,
  // },
};

export default typography;
